import theme from "assets/theme";
import React, { useContext } from "react";
import { StyleSheet, Text, View } from "react-native";
import RawCustomModal from "webComponentsFormElements/RawCustomModal.component";
import CustomButton from "webComponentsFormElements/inputs/CustomButton.component";
import { ConfirmationContext } from "webContext/Confirmation.context";

const classes = StyleSheet.create({
  modal: {
    padding: 15,
    backgroundColor: theme.color.background,
    borderRadius: 10,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  prompt: {
    padding: 10,
    fontSize: theme.font.size.body,
    color: theme.color.darkGrey,
    textAlign: "center",
  },
  footer: {
    flexDirection: "row",
    gap: 30,
  },
});

export default function ConfirmationModal() {
  const { isVisible, prompt, onCancel, onConfirm } =
    useContext(ConfirmationContext);

  return (
    <RawCustomModal visible={isVisible} style={classes.modal} zIndex={2000}>
      <Text style={classes.prompt}>{prompt}</Text>
      <View style={classes.footer}>
        <CustomButton
          title="Cancel"
          icon="close-circle-outline"
          variant="cancel"
          onPress={onCancel}
        />
        <CustomButton
          title="Confirm"
          icon="check-circle-outline"
          variant="dark"
          onPress={onConfirm}
        />
      </View>
    </RawCustomModal>
  );
}
